import type { IAdSpendChannelsFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import type { ColumnByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/column-by-keys";
import type { SuggestedColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import { processColumnsByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/utils/processColumnsByKeys";

import * as columnNames from "../../constants/column-names";

const COLUMNS_BY_KEYS: ColumnByKeys<IAdSpendChannelsFilterDto> = {
    searchChannelShare: [columnNames.SEARCH_CHANNEL_SHARE_FIELD],
    displayChannelShare: [columnNames.DISPLAY_CHANNEL_SHARE_FIELD],
};

const processAdSpendChannelsFilter = (filterDto: Partial<IAdSpendChannelsFilterDto>): readonly SuggestedColumnName[] => {
    return processColumnsByKeys<IAdSpendChannelsFilterDto>(filterDto, COLUMNS_BY_KEYS);
};

export default processAdSpendChannelsFilter;
